module.exports = __webpack_public_path__ + "img/cassie-logo-white.a9608607.svg";